/* Dansk katalog for locale-purchases-reports-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'buy.remove': 'Fjern',
  'buy.openPreview': 'Åbn forhåndsvisning',
  'buy.noPreview': 'Ingen forhåndsvisning',
  'buy.savedInBackend': 'Bilaget er gemt.',
  'buy.open': 'Åbn',
  'buy.addMoreDocs': 'Tilføj flere bilag',
  'buy.addMoreDocsHelp': 'Vedhæft flere kvitteringer eller sider til samme køb. Alle vedhæftede bilag vises her.',
  'buy.uploadDoc': 'Upload bilag',
  'buy.uploadDocHelp': 'Vedhæft kvitteringen eller fakturaen for købet. Du kan trække en fil ind, vælge fra computeren eller hente et bilag fra indbakken.',
  'buy.dropOrPick': 'Slip eller vælg bilag',
  'buy.storedIn': 'PDF eller billede gemmes i Firebase/indbakken.',
  'buy.fromInbox': 'Hent fra indbakke',
  'buy.attachments': 'Vedhæftninger',
  'buy.pickFiles': 'Vælg filer',
  'buy.dropAttachments': 'Slip vedhæftninger her',
  'buy.attachmentsNote': 'Vedhæftninger uploades til backend, når posteringen gemmes.',
  'buy.supplierSearch': 'Søg efter eller tilføj leverandør...',
  'buy.supplierSearchShort': 'Søg efter eller tilføj leverandør',
  'buy.supplierClose': 'Luk leverandørvalg',
  'buy.supplierNone': 'Ingen leverandører fundet.',
  'buy.supplierNew': 'Ny leverandør',
  'buy.name': 'Navn',
  'buy.org': 'Org.nr.',
  'buy.email': 'E-mail',
  'buy.phone': 'Telefon',
  'buy.accountClose': 'Luk kontovalg',
  'buy.searchShort': 'Søg ...',
  'buy.noAccountMatch': 'Ingen konto matcher søgningen.',
  'buy.fromInboxRead': 'Hentet fra indbakken - SuperPlumma har aflæst det, vi kunne.',
  'buy.docHelp': 'Bilaget er kvitteringen eller fakturaen, der dokumenterer købet. Træk et billede eller en PDF ind - eller tryk for at vælge fil. SuperPlumma aflæser dato, beløb, leverandør og moms og foreslår, hvordan købet skal bogføres.',
  'buy.dropReceipt': 'Slip kvitteringen her',
  'buy.dropReceiptHelp': 'Hent bilaget fra dine filer, eller vælg »Hent fra indbakke« for at bruge et bilag, der allerede er kommet ind via e-mail. SuperPlumma aflæser indholdet automatisk.',
  'buy.upload': 'Upload',
  'buy.type': 'Type køb',
  'buy.typeHelp': 'Vælg, hvordan købet skal registreres. »Betalt køb« er et køb, der allerede er betalt. »Leverandørfaktura« bruges, når fakturaen skal betales senere eller er delvist betalt (bliver til leverandørgæld). »Kladder« viser påbegyndte køb, som du endnu ikke har bogført.',
  'buy.description': 'Beskrivelse',
  'buy.descriptionPh': 'F.eks. abonnement eller rejse',
  'buy.toggleVat': 'Skift mellem ekskl. og inkl. moms',
  'buy.amountExInc': 'Beløb ekskl./inkl. moms',
  'buy.amountExIncHelp': 'Tryk for at skifte mellem at indtaste beløbet uden moms (netto) eller med moms (brutto). Plumme omregner automatisk mellem de to. »Ekskl. moms« er selve omkostningen, »inkl. moms« er det samlede beløb, du betalte.',
  'buy.vatRate': 'Momssats',
  'buy.vatRateHelp': 'Momssatsen på købet. 25 % er normalsatsen, 15 % gælder fødevarer (mad), 12 % gælder bl.a. persontransport og overnatning, og 0 % bruges til momsfrie køb. Momsen på et køb er indgående moms, som du får fradrag for.',
  'buy.pickCategory': 'Konto/kategori',
  'buy.category': 'Kategori',
  'buy.categoryHelp': 'Hvilken slags omkostning det er. Kategorien bestemmer, hvilken konto købet bogføres på, så det havner rigtigt i resultatopgørelsen og skattemeldingen.',
  'buy.supplier': 'Leverandør',
  'buy.accountFromHistory': 'Omkostningskonto foreslået ud fra tidligere køb hos leverandøren. Du kan ændre den på købslinjen.',
  'buy.date': 'Købsdato',
  'buy.invoiceNumber': 'Fakturanummer',
  'buy.invoiceNumberPh': 'F.eks. 100245',
  'buy.dueDate': 'Forfaldsdato',
  'buy.lines': 'Linjer',
  'buy.linesHelp': 'Hver linje er én omkostning på bilaget med eget beløb, momssats og kategori. Har kvitteringen flere forskellige varer eller momssatser, laver du én linje pr. type. Du kan trække linjerne for at ændre rækkefølgen.',
  'buy.addLine': 'Tilføj linje',
  'buy.payment': 'Betaling',
  'buy.paymentHelp': 'For leverandørfaktura vælger du, om fakturaen er betalt. Ubetalte fakturaer gemmes som åben leverandørgæld, så betalingen kan registreres senere.',
  'buy.immediatePaymentHelp': 'Et almindeligt køb er allerede betalt. Vælg, hvilken konto betalingen gik fra, og datoen, den blev betalt.',
  'buy.paid': 'Betalt',
  'buy.unpaid': 'Ikke betalt',
  'buy.paidFrom': 'Betalt fra',
  'buy.choosePaymentSource': 'Vælg betalingskilde',
  'buy.paidDate': 'Betalingsdato',
  'buy.paidDateHelp': 'Den dato, købet blev betalt. Købsdatoen styrer regnskabs- og momsperioden for selve købet.',
  'buy.dateLabel': 'Dato',
  'buy.addPartPayment': 'Tilføj delbetaling',
  'buy.addPartPaymentHelp': 'Registrér endnu en betaling. Summen af delbetalingerne trækkes fra totalen - det, der er tilbage, vises som »mangler«.',
  'buy.remaining': 'Mangler',
  'buy.remainingHelp': 'Forskellen mellem det samlede beløb og det, du har registreret som delbetalinger. Er den 0, er købet fuldt udlignet.',
  'buy.preview': 'Forhåndsvisning',
  'buy.previewHelp': 'Forhåndsvisning af det bilag, du har uploadet. Har du ikke uploadet et bilag, kan du gøre det her.',
  'buy.dropReceiptLong': 'Slip kvitteringen her - træk et billede eller en PDF ind, eller tryk for at vælge fil.',
  'buy.summaryHelp': 'Opsummeringen viser netto, moms og det samlede beløb, du betaler.',
  'buy.saveDraft': 'Gem kladde',
  'buy.saveDraftHelp': 'Gemmer købet som en kladde uden at bogføre det. Bilag og betalinger markeres ikke som bogført, før du afslutter købet.',
  'buy.title': 'Betalt køb',
  'buy.subtitle': 'Registrér et køb - upload bilaget, så foreslår vi resten.',
  'buy.drafts': 'Kladder',
  'buy.draftsSub': 'Påbegyndte køb og aktiver, du endnu ikke har bogført',
  'buy.draftsSearchPh': 'Leverandør, beskrivelse, fakturanr. eller beløb',
  'buy.showMore': 'Vis flere',
  'buy.noDrafts': 'Ingen kladder',
  'buy.invoiceNoShort': 'Fakturanr.',
  'buy.delete': 'Slet',
  'buy.deleteDraftTitle': 'Slet kladde?',
  'buy.deleteDraftConfirm': 'Ja, slet kladde',
  'buy.deleteDraftBody': 'Er du sikker på, at du vil slette kladden for',
  'buy.resetTitle': 'Nulstil formularen, og start forfra',
  'buy.reset': 'Nulstil',
  'buy.howRegister': 'Hvordan vil du registrere købet?',
  'buy.howRegisterSub': 'Upload gerne bilaget først - så foreslår vi resten for dig.',
  'buy.stepByStep': 'Trin for trin',
  'buy.stepByStepHelp': 'Fører dig gennem købet én del ad gangen - først bilag, så dato, linjer og betaling. God, når du vil tage det roligt.',
  'buy.stepByStepShort': 'Bilag først, derefter dato, linjer og betaling.',
  'buy.onePage': 'Alt på én side',
  'buy.onePageHelp': 'Viser hele købsformularen samlet på én side. God, når du er vant til at registrere køb og vil have alt foran dig.',
  'buy.onePageShort': 'Hele købsformularen samlet.',
  'buy.toSteps': 'Skift til trin for trin',
  'buy.toOnePage': 'Skift til alt på én side',
  'buy.back': 'Tilbage',
  'buy.next': 'Næste',
  'buy.backToVouchers': 'Tilbage til transaktioner',
  'buy.salesType': 'Salgstype',
  'buy.paidTo': 'Betalt til',
  'buy.payOperating': 'Driftskonto',
  'buy.payCash': 'Kontant',
  'buy.payPrivate': 'Privat',
  'buy.privateDeposit': 'Privat indskud',
  'buy.whatSold': 'Hvad solgte du?',
  'buy.amountExVat': 'Beløb ekskl. moms',
  'buy.amountIncVat': 'Beløb inkl. moms',
  'buy.vatLabel': 'Moms',
  'buy.otherSale': 'Andet salg',
  'buy.invoiceOrQuote': 'Faktura / tilbud',
  'buy.switchMode': 'Skift tilstand',
  'buy.moreOptions': 'Flere valg',
  'buy.postAs': 'Bogfør som',
  'buy.backendUploadNotReady': 'Backend-upload er ikke klar.',
  'buy.multipleUploadedShowFirst': 'Flere bilag blev uploadet. Viser det første her.',
  'buy.uploadFailed': 'Kunne ikke uploade bilaget.',
  'buy.dropReceiptTitle': 'Slip kvitteringen her',
  'buy.dropReceiptSubtitle': '...så hjælper vi dig med at placere den rigtigt. Træk et billede eller en PDF ind, eller tryk for at vælge fil.',
  'buy.attachedCount': '{count} bilag tilknyttet',
  'buy.uploading': 'Uploader...',
  'buy.chooseFile': 'Vælg fil',
  'buy.dropToUpload': 'Slip bilaget for at uploade',
  'buy.accountFallbackOperating': 'Driftskonto · 1920',
  'buy.accountFallbackCash': 'Kontant',
  'buy.accountFallbackPrivate': 'Privat udlæg',
  'buy.accountFallbackCash1900': 'Kontant - 1900',
  'buy.accountFallbackPrivate2060': 'Privat - 2060',
  'buy.addSupplierQuery': 'Tilføj »{query}«',
  'buy.chartNotConnected': 'Kontoplanen er ikke koblet til lagring.',
  'buy.accountAdded': 'Kontoen er tilføjet.',
  'buy.accountSaveFailed': 'Kunne ikke gemme kontoen.',
  'buy.chooseAccount': 'Vælg konto',
  'buy.forQuery': 'for »{query}«',
  'buy.newCustomAccountTitle': 'Ny brugerdefineret konto',
  'buy.saving': 'Gemmer...',
  'buy.saveAccount': 'Gem konto',
  'buy.accountNamePlaceholder': 'F.eks. Softwareudvikling',
  'buy.accountHelperText': 'Kontoen bliver tilgængelig i kontosøgningen og knyttes til standardkontoen til rapportering og årsafslutning.',
  'buy.inventoryProduct': 'Lagervare',
  'buy.notTracked': 'Ikke lagerført',
  'buy.quantityInStock': 'Antal ind på lager',
  'buy.inStockCount': '{n} på lager',
  'buy.inventoryLineToggle': 'Skal lagerføres',
  'buy.inventoryLineToggleHelp': 'Slå til, når købet skal øge beholdningen af en registreret lagervare.',
  'buy.inventorySearchPlaceholder': 'Vælg lagervare',
  'buy.inventorySearch': 'Søg efter navn, varenummer, SKU eller EAN',
  'buy.inventorySearchEmpty': 'Ingen lagerførte varer matcher søgningen.',
  'buy.inventoryOpenProducts': 'Åbn produkter',
  'buy.inventoryUnitsInStock': 'på lager',
  'inventoryPurchase.settingsTitle': 'Lagerføring på køb',
  'inventoryPurchase.settingsHelp': 'Vis et valgfrit lagerfelt på købslinjer, så et køb kan øge beholdningen af en registreret lagervare.',
  'inventoryPurchase.offHelp': 'Lagerfeltet er skjult på nye køb. Produkter og tidligere lagerbevægelser bevares.',
  'inventoryPurchase.migratedTitle': 'Lagerføring på køb er slået til',
  'inventoryPurchase.migratedText': 'Virksomheden har allerede produkter med automatisk lagerføring. Derfor er lagerkoblingen på købslinjer aktiveret, så den eksisterende arbejdsgang fortsætter.',
  'inventoryPurchase.acknowledge': 'Jeg forstår',
  'inventoryPurchase.acknowledgeError': 'Kunne ikke gemme bekræftelsen.',
  'inventoryPurchase.openSettings': 'Åbn indstillinger',
  'inventoryPurchase.disableTitle': 'Slå lagerføring på køb fra?',
  'inventoryPurchase.disableConfirm': 'Slå fra',
  'inventoryPurchase.disableWarning': 'Lagerfeltet skjules på nye køb. Køb kan så ikke knyttes til lagerførte produkter, og beholdningen kan blive forkert, hvis den ikke kontrolleres og justeres manuelt.',
  'inventoryPurchase.disableHistory': 'Eksisterende produkter og historiske lagerbevægelser slettes ikke. Optæl lageret, og registrér nødvendige justeringer manuelt.',
  'inventoryPurchase.enabledLabel': 'Lagerføring på køb',
  'inventoryPurchase.disabledLabel': 'Lagerføring på køb',
  'buy.noDescription': 'Uden beskrivelse',
  'buy.attachmentFallback': 'Bilag',
  'buy.lockVatTitle': 'Momsperioden er indberettet',
  'buy.lockYearTitle': 'Regnskabsåret er afsluttet',
  'buy.lockBankTitle': 'Bankperioden er afstemt',
  'buy.lockVatTarget': 'momsperioden',
  'buy.lockYearTarget': 'årsafslutningen',
  'buy.lockBankTarget': 'bankafstemningen',
  'buy.lockWarningText': '{title}. Du kan stadig ændre beskrivelse og omkostningskonto/kategori på købet, men købsdato, beløb, momskode og betalingsfelter er låst. Åbn eller korrigér {target}, hvis du skal ændre disse felter.',
  'buy.lockVatWarningText': '{title}. Købsdato, beløb og momskode er låst, men beskrivelse, omkostningskonto/kategori og betalingskonto kan stadig korrigeres. Åbn eller korrigér {target}, hvis momsgrundlaget skal ændres.',
  'buy.backendSaveNotReady': 'Backend-lagring er ikke klar.',
  'buy.needAtLeastOneLine': 'Tilføj mindst én købslinje.',
  'buy.needDescriptionAllLines': 'Indtast beskrivelse på alle linjer, før du bogfører.',
  'buy.needContentForDraft': 'Tilføj en linje, leverandør eller et bilag, før du gemmer kladden.',
  'buy.needSupplierForInvoice': 'Vælg leverandør, eller udfyld leverandørnavn, før du gemmer delbetaling/leverandørfaktura.',
  'buy.draftSaved': 'Kladde gemt.',
  'buy.attachmentUpdated': 'Bilaget er opdateret.',
  'buy.invoiceRegisteredOpen': 'Faktura registreret som åben leverandørfaktura.',
  'buy.purchaseBooked': 'Køb bogført! Bilaget ligger nu under Transaktioner.',
  'buy.purchaseSaveFailed': 'Kunne ikke gemme købet.',
  'buy.docsFetchedFromInbox': '{count} bilag hentet fra indbakken',
  'buy.fullPayment': 'Fuld betaling',
  'buy.partPayment': 'Delbetaling',
  'buy.partPaymentWarning': 'Delbetaling registreres som leverandørfaktura. Resten føres som leverandørgæld på 2400, indtil den betales.',
  'buy.partPaymentLabel': 'Delbetaling {n}',
  'buy.remainingSuffix': '· resterer',
  'buy.unpaidWillBeInvoice': 'Uden registreret betaling gemmes dette som en åben leverandørfaktura. Du kan registrere betaling senere.',
  'buy.forgotReceiptTitle': 'Har du glemt bilaget?',
  'buy.registerInvoice': 'Registrér faktura',
  'buy.bookPurchase': 'Bogfør køb',
  'buy.registerInvoiceHelp': 'Gemmer fakturaen som åben leverandørgæld. Den dukker op under leverandøren, og du registrerer betaling, når den er betalt.',
  'buy.bookPurchaseHelp': 'Gemmer købet i regnskabet. Bilaget havner under »Transaktioner«, og beløbene føres på de rigtige konti.',
  'buy.typeBadgeInvoice': 'Faktura',
  'buy.typeBadgeAsset': 'Aktiv',
  'buy.draftDeleteNotConnected': 'Sletning af kladder er ikke koblet til backend.',
  'buy.draftDeleted': 'Kladde slettet.',
  'buy.draftDeleteFailed': 'Kunne ikke slette kladde.',
  'buy.pageHelpDrafts': 'Her registrerer du alt, hvad virksomheden køber. Vælg »Kladder« i rullemenuen for at se påbegyndte køb, som du endnu ikke har bogført.',
  'buy.draftsPageHelp': 'Køb, du har påbegyndt, men ikke gennemført, gemmes her. Åbn en kladde for at fortsætte, eller slet dem, du ikke har brug for.',
  'buy.viewOptionsLabel': 'Visningsvalg',
  'buy.assetsLabel': 'Aktiver',
  'buy.noDraftsMatchSearch': 'Ingen kladder matcher søgningen.',
  'buy.draftsEmptyHint': 'Påbegyndte køb, som du gemmer som kladde, vises her.',
  'buy.colSupplier': 'Leverandør',
  'buy.noSupplier': 'Uden leverandør',
  'buy.colType': 'Type',
  'buy.colInvoiceNo': 'Fakturanr.',
  'buy.colDate': 'Dato',
  'buy.colAmount': 'Beløb',
  'buy.thisPurchaseFallback': 'dette køb',
  'buy.cannotBeUndone': '? Dette kan ikke fortrydes.',
  'buy.formReset': 'Formularen er nulstillet',
  'buy.editPurchaseSubtitle': 'Opdater bilaget, og gem ændringerne i backend.',
  'buy.newPurchasePageHelp': 'Her registrerer du alt, hvad virksomheden køber - varer, udstyr, abonnementer, rejser. Upload bilaget, så aflæser SuperPlumma detaljerne og bogfører omkostningen på den rigtige konto med den rigtige moms.',
  'buy.defaultLineDescription': 'Køb',
  'buy.customerFallback': 'Kunde',
  'buy.supplierAndDateTitle': 'Leverandør og dato',
  'buy.supplierAndDateInvoiceHelp': 'Hvem du købte fra og hvornår. Fakturadatoen er datoen på fakturaen, og forfaldsdatoen er, hvornår den skal betales. Fakturanummeret er leverandørens eget nummer på fakturaen.',
  'buy.supplierAndDatePurchaseHelp': 'Købsdatoen afgør, hvilken regnskabs- og momsperiode købet havner i. Brug datoen på kvitteringen.',
  'buy.katFixedAssets': 'Driftsmidler / udstyr',
  'buy.katRent': 'Husleje',
  'buy.katPhoneInternet': 'Telefon og internet',
  'buy.katSoftware': 'Software / abonnement',
  'buy.katTravel': 'Rejser og diæter',
  'buy.katRepresentation': 'Repræsentation',
  'buy.acct4000': 'Råvarer og halvfabrikata',
  'buy.acct4300': 'Indkøb af varer til videresalg',
  'buy.acct4500': 'Fremmedydelser og underleverandører',
  'buy.acct5000': 'Løn til medarbejdere',
  'buy.acct5400': 'Arbejdsgiverafgift',
  'buy.acct5900': 'Gaver til medarbejdere',
  'buy.acct6000': 'Afskrivninger',
  'buy.acct6100': 'Fragt og transportomkostninger',
  'buy.acct6200': 'Energi, el og varme',
  'buy.acct6300': 'Leje af lokaler',
  'buy.acct6320': 'Renovation, vand, afløb m.v.',
  'buy.acct6340': 'Lys, varme',
  'buy.acct6360': 'Rengøring',
  'buy.acct6400': 'Leje af maskiner',
  'buy.acct6500': 'Værktøj og inventar',
  'buy.acct6540': 'Inventar og udstyr',
  'buy.acct6550': 'Driftsmaterialer',
  'buy.acct6560': 'Rekvisitter',
  'buy.acct6600': 'Reparation og vedligeholdelse af bygninger',
  'buy.acct6690': 'Reparation og vedligeholdelse, andet',
  'buy.acct6700': 'Revision og regnskab',
  'buy.acct6720': 'Juridisk bistand',
  'buy.acct6790': 'Andre fremmede ydelser',
  'buy.acct6800': 'Kontorartikler',
  'buy.acct6810': 'IT-omkostninger',
  'buy.acct6820': 'Tryksager',
  'buy.acct6900': 'Telefon',
  'buy.acct6940': 'Porto',
  'buy.acct7000': 'Brændstof til transportmidler',
  'buy.acct7020': 'Vedligeholdelse af bil',
  'buy.acct7040': 'Forsikring og afgifter for transportmidler',
  'buy.acct7100': 'Kørselsgodtgørelse',
  'buy.acct7140': 'Rejseomkostninger, ikke indberetningspligtige',
  'buy.acct7150': 'Diætomkostninger',
  'buy.acct7160': 'Rejseomkostninger, indberetningspligtige',
  'buy.acct7300': 'Salgsomkostninger',
  'buy.acct7320': 'Reklame og annoncer',
  'buy.acct7350': 'Repræsentation, fradragsberettiget',
  'buy.acct7360': 'Repræsentation, ikke fradragsberettiget',
  'buy.acct7400': 'Kontingent',
  'buy.acct7500': 'Forsikringspræmie',
  'buy.acct7600': 'Licens, patent og royalty',
  'buy.acct7700': 'Andre driftsomkostninger',
  'buy.acct7770': 'Bank- og kortgebyrer',
  'buy.acct7790': 'Anden omkostning',
  'buy.acct8050': 'Renteindtægt',
  'buy.acct8150': 'Renteudgift',
  'buy.acct8300': 'Betalbar skat',
  'buy.fallbackCostName': 'Omkostning',
  'buy.fallbackAccountName': 'Konto',
  'buy.grp40': 'Vareforbrug',
  'buy.grp43': 'Varer til videresalg',
  'buy.grp45': 'Indkøb af tjenesteydelser',
  'buy.grp50': 'Løn',
  'buy.grp54': 'Arbejdsgiverafgift',
  'buy.grp59': 'Personaleomkostninger',
  'buy.grp60': 'Afskrivninger',
  'buy.grp61': 'Fragt og transport',
  'buy.grp62': 'Energi og varme',
  'buy.grp63': 'Lokaler',
  'buy.grp64': 'Leje af maskiner og udstyr',
  'buy.grp65': 'Værktøj og inventar',
  'buy.grp66': 'Reparation og vedligeholdelse',
  'buy.grp67': 'Fremmede ydelser',
  'buy.grp68': 'Kontoromkostninger',
  'buy.grp69': 'Telefon, porto m.v.',
  'buy.grp70': 'Transportmidler',
  'buy.grp71': 'Rejser og diæter',
  'buy.grp73': 'Salg og repræsentation',
  'buy.grp74': 'Kontingenter',
  'buy.grp75': 'Forsikring',
  'buy.grp76': 'Licens og royalty',
  'buy.grp77': 'Andre driftsomkostninger',
  'buy.grp15': 'Kortfristede tilgodehavender',
  'buy.grp24': 'Leverandørgæld',
  'buy.groupAssets': 'Aktiver',
  'buy.groupEquityAndLiabilities': 'Egenkapital og gæld',
  'buy.groupIncome': 'Indtægter',
  'buy.groupCostOfGoods': 'Vareforbrug',
  'buy.groupPayrollAndPersonnel': 'Løn og personaleomkostninger',
  'buy.groupOtherOperating': 'Andre driftsomkostninger',
  'buy.groupFinanceAndTax': 'Finans og skat',
  'buy.groupAccountsFallback': 'Konti',
  'rep.trial.onlyMovement': 'Vis kun konti med bevægelse',
  'rep.trial.showInactive': 'Vis også inaktive konti',
  'rep.trial.payrollLiability': 'Skyldig løn',
  'rep.trial.holidayPayLiability': 'Skyldige feriepenge',
  'rep.trial.oneEmployee': '{n} medarbejder',
  'rep.trial.employeeCount': '{n} medarbejdere',
  'rep.trial.otherPayrollLiability': 'Alle posteringer på 2930',
  'rep.trial.allAccountEntries': 'Alle posteringer på {account}',
  'rep.trial.payrollRun': 'Lønkørsel {period}',
  'rep.trial.term': '{term}. periode {year}',
  'rep.trial.accrualYear': 'Optjeningsår {year}',
  'vehiclePolicy.dialogTitle': 'Køretøj og køretøjsomkostninger',
  'vehiclePolicy.intro': 'Vælg, hvordan Plumme skal behandle brændstof, værksted og andre tydelige køretøjsomkostninger. Dette er en arbejdsindstilling for bilagsforslag og registrerer ikke et køretøj som aktiv.',
  'vehiclePolicy.optionVat': 'Køretøj med momsfradrag',
  'vehiclePolicy.optionVatSub': 'Virksomheden ejer eller leaser køretøjet, køretøjstypen giver fradragsret, og omkostningen vedrører registreret momspligtig virksomhed.',
  'vehiclePolicy.optionNoVat': 'Køretøj uden momsfradrag',
  'vehiclePolicy.optionNoVatSub': 'Foreslå køretøjsomkostningen uden fradrag for indgående moms.',
  'vehiclePolicy.optionManual': 'Kontrollér hvert bilag manuelt',
  'vehiclePolicy.optionManualSub': 'Plumme foreslår konto, men lader momsfradraget stå til kontrol.',
  'vehiclePolicy.validFrom': 'Gælder fra',
  'vehiclePolicy.noEndDateWarning': 'Uden slutdato gælder valget, indtil du ændrer det. Et nyt valg afslutter automatisk det forrige fra ændringsdatoen.',
  'vehiclePolicy.responsibility': 'Jeg bekræfter, at oplysningen er korrekt, og forstår, at jeg selv skal opdatere den, hvis køretøjet sælges, leasingaftalen ophører, eller køretøjstypen eller brugen ændres.',
  'vehiclePolicy.receiptTitle': 'Afklar køretøjet én gang',
  'vehiclePolicy.receiptText': 'Så kan senere brændstof- og værkstedsbilag automatisk få det rigtige momsforslag.',
  'vehiclePolicy.changeFromReceiptTitle': 'Ændr køretøjsreglen?',
  'vehiclePolicy.changeFromReceiptText': 'Du har sat dette køretøjsbilag til 0 % momsfradrag. Skal det kun gælde dette bilag, eller skal Plumme fremover behandle køretøjsomkostninger uden momsfradrag, fordi køretøjet er solgt, leasingen er ophørt, eller fradragsretten ikke længere gælder?',
  'vehiclePolicy.changeFromReceiptDate': 'Den nye regel gælder fra {date}.',
  'vehiclePolicy.receiptOnly': 'Kun dette bilag',
  'vehiclePolicy.updateToNoVat': 'Brug 0 % fremover',
  'vehiclePolicy.settingsTitle': 'Køretøj og køretøjsomkostninger',
  'vehiclePolicy.settingsText': 'Styrer automatiske forslag til brændstof, værksted og andre tydelige køretøjsomkostninger. Indstillingen bogfører ikke og opretter hverken aktiv eller leasingaftale.',
  'vehiclePolicy.choose': 'Vælg indstilling',
  'vehiclePolicy.change': 'Ændr indstilling',
  'vehiclePolicy.save': 'Gem og anvend',
  'vehiclePolicy.saved': 'Køretøjsindstillingen er gemt.',
  'vehiclePolicy.saveError': 'Køretøjsindstillingen kunne ikke gemmes.',
  'vehiclePolicy.chooseError': 'Vælg, hvordan køretøjsbilag skal behandles.',
  'vehiclePolicy.confirmError': 'Bekræft, at virksomheden selv holder oplysningen opdateret.',
  'vehiclePolicy.notConfigured': 'Ikke konfigureret – køretøjsbilag skal kontrolleres',
  'vehiclePolicy.activeFrom': 'Gælder fra',
  'vehiclePolicy.noEndDate': 'ingen slutdato',
  'vehiclePolicy.mode.vat_deductible': 'Køretøj med momsfradrag',
  'vehiclePolicy.mode.no_vat_deduction': 'Køretøj uden momsfradrag',
  'vehiclePolicy.mode.manual_review': 'Manuel kontrol af hvert bilag',
  'buy.vatDeduction': 'Fradrag for indgående moms',
  'buy.vatDeductionFull': '100 %',
  'buy.vatDeductionNone': '0 %',
  'buy.vatDeductionPartial': 'Delvis',
  'buy.vatDeductionPercent': 'Fradragsprocent',
  'buy.fixedAssetLine': 'Registrer linjen som aktiv',
  'buy.fixedAssetLineHelp': 'Linjen tilføjes aktivregistret i stedet for kun at blive behandlet som omkostning.',
  'buy.fixedAssetFallback': 'Anlægsaktiv',
  'buy.projectForLine': 'Projekt for denne linje',
  'sup.credit.created': 'Leverandørens kreditnota er bogført.',
  'sup.credit.refunded': 'Refusionen er bogført.',
  'sup.credit.title': 'Registrer leverandørkreditnota',
  'sup.credit.refundTitle': 'Registrer refusion af kreditnota',
  'sup.credit.action': 'Bogfør kreditnota',
  'sup.credit.refundAction': 'Registrer refusion',
});
